import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(7, 35, 62, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  z-index: 1000;
`;

export const Caixa = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(7, 35, 62, 0.25);
  width: 100%;
  max-width: 460px;
  box-sizing: border-box;
  padding: 28px 24px 20px 24px;
  text-align: left;
`;

export const Titulo = styled.h3<{ erro?: boolean }>`
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 700;
  color: ${({ erro }) => (erro ? '#B00020' : '#1C4584')};
`;

export const Texto = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #363d40;
`;

export const Acoes = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const BotaoOk = styled.button`
  min-width: 112px;
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  background: #1c4584;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #0f2e4e;
  }

  &:focus-visible {
    outline: 2px solid #2e80c3;
    outline-offset: 2px;
  }
`;
